// NPF child-mode flag. Lagras i localStorage (P0), default AV.
// Samma mönster som dark mode: efter setItem måste vi dispatcha 'storage'-eventet
// manuellt eftersom webbläsaren annars bara fyrar det i andra flikar, inte i den
// flik som gjorde ändringen (jfr DarkModeToggle.tsx). Utan detta byts inte temat
// förrän efter en omladdning.
const CHILD_MODE_KEY = 'childMode';

export const isChildModeEnabled = (): boolean => localStorage.getItem(CHILD_MODE_KEY) === 'on';

export const setChildMode = (enabled: boolean): void => {
  localStorage.setItem(CHILD_MODE_KEY, enabled ? 'on' : 'off');
  window.dispatchEvent(new Event('storage'));
};
